const copy = {
  ctas: {
    startNewChat: "Start new chat",
    viewChatHistory: "View chat history",
    viewAllChatHistory: "View all chats",
    viewChatHistoryNoItems: "You have no recent chats.",
    newMessage: "New Messages",
  },
  fields: {
    input: {
      ariaLabel: "input for asking a question to the AI Help Center assistant",
      placeholder: "Ask a question",
    },
    deprecatedInput: {
      ariaLabel: "input",
      placeholder: "Enter chat text.",
    },
  },
  errors: {
    messageMinLength: (minLength: number) =>
      `Message is too short. Your message must be at least ${minLength} characters.`,
  },
  loaders: {
    isTypingDefaultText: "AI is typing.",
  },
  variants: {
    oopsTitle: "We could not load your chat",
    oopsDescription: "Try reloading the page.",
  },
};

export default copy;
